import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Heading from '../Heading';
import { IconChevronRight, IconChevronDown } from '../icons/Icons';

export default class AccordionHeading extends React.PureComponent {
    static displayName = 'AccordionHeading';

    static propTypes = {
        /** Heading contents */
        children: PropTypes.node.isRequired,

        /** click handler from AccordionItem */
        handleHeadingClick: PropTypes.func,

        /** The heading style for all items. */
        headingAppearance: PropTypes.oneOf(['h4', 'h5', 'h5Caps', 'h6']),

        /** The heading tag to use for all items. */
        headingLevel: PropTypes.number,

        /** id used to construct the aria relationship between the heading and
         * content. It's only necessary to provide an id if there's more than
         * one Accordion on the page.  */
        id: PropTypes.string,

        /** If the contents are expanded */
        isExpanded: PropTypes.bool,

        /** Additional class that is applied to the wrapper around the heading */
        className: PropTypes.string
    };

    static defaultProps = {
        headingLevel: 3,
        headingAppearance: 'h6',
        isExpanded: false,
        className: undefined
    };

    render() {
        const {
            children,
            headingLevel,
            headingAppearance,
            isExpanded,
            handleHeadingClick,
            className,
            id
        } = this.props;

        return (
            <div
                className={cx('sarsa-accordion-heading', className)}
                data-component="AccordionHeading">
                <Heading
                    headingLevel={headingLevel}
                    appearance={headingAppearance}>
                    <button
                        id={`${id}-heading`}
                        className="sarsa-accordion-heading-button"
                        aria-controls={id}
                        aria-expanded={isExpanded}
                        onClick={handleHeadingClick}>
                        <span className={`sarsa-accordion-heading-icon size-${headingAppearance}`}>
                            {isExpanded
                                ? <IconChevronDown size="md" />
                                : <IconChevronRight size="md" />}
                        </span>
                        <span>
                            {children}
                        </span>

                    </button>
                </Heading>
            </div>

        );
    }
}